import React from 'react';
import { ArrowRight } from 'lucide-react';
import { destinations } from '../data/mock';
import { useLanguage } from '../context/LanguageContext';

const DestinationCard = ({ destination }) => {
  const { t } = useLanguage();
  
  return (
    <div className="relative group overflow-hidden rounded-lg cursor-pointer">
      {/* Background Image */}
      <div className="aspect-[4/3] overflow-hidden">
        <img
          src={destination.image}
          alt={destination.name}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
      </div>
      
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
      
      {/* Content */}
      <div className="absolute bottom-0 left-0 right-0 p-5">
        <h3 className="text-xl font-bold text-white mb-1">
          {destination.name}
        </h3>
        <p className="text-white/80 text-sm mb-3">
          {destination.toursCount} {t('tours')}
        </p>
        <div className="flex items-center gap-2 text-teal-400 text-sm font-medium group-hover:text-teal-300 transition-colors">
          <span>{t('viewAll')}</span>
          <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
        </div>
      </div>
    </div>
  );
};

const DestinationsSection = () => {
  const { t } = useLanguage();
  
  return (
    <section className="py-16 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-teal-500 mb-4">
          {t('destinationsTitle')}
        </h2>
        <p className="text-center text-gray-600 mb-12">{t('destinationsSubtitle')}</p>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {destinations.map((destination) => (
            <DestinationCard key={destination.id} destination={destination} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default DestinationsSection;
